import { AuthenticationErrorWithClaimResponse } from "AuthenticationError";
import captionService from "CaptionService";
import { LogonProviderType } from "LogonProviderType";
import logonService from "LogonService";

export enum ImpersonationResult {
  Success,
  ClaimFailed,
  BeginSessionFailed,
}

export interface ImpersonationResponse {
  result: ImpersonationResult;
  errorMessage: string | undefined;
}

export async function impersonateUserAsync(useName: string): Promise<ImpersonationResponse> {
  const impersonationResponse: ImpersonationResponse = {
    result: ImpersonationResult.Success,
    errorMessage: undefined,
  };
  try {
    await logonService.impersonateUserAsync(LogonProviderType.Contact, useName);
  } catch (error) {
    impersonationResponse.errorMessage = (error as Error).message;

    if (error instanceof AuthenticationErrorWithClaimResponse) {
      impersonationResponse.errorMessage = captionService.getString(
        "b3ca7768-2a3d-4cf5-a10b-37d071810097",
        "Your organization code and/or email address is incorrect.",
      );
      impersonationResponse.result = ImpersonationResult.ClaimFailed;
    } else {
      impersonationResponse.result = ImpersonationResult.BeginSessionFailed;
    }
  }

  return impersonationResponse;
}
